import { Fragment, ReactElement } from 'react';
import EditNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/edit';

const EditNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <EditNotificationsCivilStatusShared />
    </Fragment>
  );
};

EditNotificationsCivilStatusPage.displayName = 'Edit Notifications Civil Status component';

export default EditNotificationsCivilStatusPage;
